module.exports = __webpack_public_path__ + "static/img/2.b692630.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/TechnicalSupport/detect/2.jpg
// module id = vkJ3
// module chunks = 13